import { render, staticRenderFns } from "./UserSupportDataTable.vue?vue&type=template&id=30ba5da4&scoped=true"
import script from "./UserSupportDataTable.vue?vue&type=script&lang=js"
export * from "./UserSupportDataTable.vue?vue&type=script&lang=js"
import style0 from "./UserSupportDataTable.vue?vue&type=style&index=0&id=30ba5da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba5da4",
  null
  
)

export default component.exports